import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { SIZES } from '@fupa/fupa-uikit';
import { ProgressBar } from 'app/components/tv/customControls/ProgressBar';
const Container = styled.div.withConfig({
  componentId: "sc-5lon8t-0"
})(["padding:", " calc(", " + env(safe-area-inset-right)) ", " calc(", " + env(safe-area-inset-left));display:flex;justify-content:space-between;background:linear-gradient(rgba(0,0,0,1),rgba(0,0,0,0));z-index:1;visibility:", ";"], SIZES['8'], SIZES['32'], SIZES['8'], SIZES['32'], props => props.show ? 'visible' : 'hidden');
const getProgressWithStartSec = (startSec, currentTime) => {
  if (currentTime === 0) {
    return 0;
  }
  return currentTime - startSec;
};
export const ProgressContainer = _ref => {
  let {
    show,
    playerRef,
    playerReady,
    playlist,
    currentVideoIndex,
    video
  } = _ref;
  const [currentTime, setCurrentTime] = useState(0);
  const progressContainerRef = useRef(null);

  // set current time for progress bar
  useEffect(() => {
    const player = playerRef.current;
    if (!playerReady || !player) {
      return;
    }
    const handleTimeUpdate = () => setCurrentTime(player.currentTime());
    player.on('timeupdate', handleTimeUpdate);
    return () => {
      if (player) {
        player.off('timeupdate', handleTimeUpdate);
      }
    };
  }, [playerReady]);
  useEffect(() => {
    setCurrentTime(0);
  }, [currentVideoIndex]);
  const progressBars = playlist.getVideos().map((elem, index) => {
    if (index === currentVideoIndex) {
      var _ref2, _video$videoDuration, _playerRef$current;
      const duration = (_ref2 = (_video$videoDuration = video.videoDuration) !== null && _video$videoDuration !== void 0 ? _video$videoDuration : (_playerRef$current = playerRef.current) === null || _playerRef$current === void 0 ? void 0 : _playerRef$current.duration()) !== null && _ref2 !== void 0 ? _ref2 : 20;
      const startTime = video.startTime;
      const playedTime = startTime ? getProgressWithStartSec(startTime, currentTime) : currentTime;
      return /*#__PURE__*/React.createElement(ProgressBar, {
        key: elem.slug,
        progress: playedTime / duration * 100
      });
    } else if (index < currentVideoIndex) {
      return /*#__PURE__*/React.createElement(ProgressBar, {
        key: elem.slug,
        progress: 100
      });
    } else {
      return /*#__PURE__*/React.createElement(ProgressBar, {
        key: elem.slug,
        progress: 0
      });
    }
  });
  return /*#__PURE__*/React.createElement(Container, {
    ref: progressContainerRef,
    show: show,
    "data-sentry-element": "Container",
    "data-sentry-component": "ProgressContainer",
    "data-sentry-source-file": "ProgressContainer.tsx"
  }, progressBars);
};